export default function Team() {
  const team = [
    {
      name: 'Dr. Sarah Anderson',
      role: 'Medical Director',
      image: 'https://public.readdy.ai/ai/img_res/0adb317c6b19d38ca0dc85155128fa1e.jpg',
      linkedin: 'https://www.linkedin.com'
    },
    {
      name: 'Dr. Michael Chen',
      role: 'Aesthetic Physician',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20male%20asian%20doctor%20in%20white%20medical%20coat%20friendly%20smile%20professional%20appearance%20medical%20expert%20clean%20background&width=500&height=500&seq=team002&orientation=squarish',
      linkedin: 'https://www.linkedin.com'
    },
    {
      name: 'Dr. Emily Roberts',
      role: 'Dermatologist',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20female%20dermatologist%20in%20white%20coat%20warm%20smile%20confident%20professional%20medical%20expert%20clean%20simple%20background&width=500&height=500&seq=team003&orientation=squarish',
      linkedin: 'https://www.linkedin.com'
    },
    {
      name: 'Dr. James Wilson',
      role: 'Cosmetic Surgeon',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20male%20surgeon%20in%20white%20medical%20coat%20professional%20demeanor%20experienced%20doctor%20clean%20background%20high%20quality%20photo&width=500&height=500&seq=team004&orientation=squarish',
      linkedin: 'https://www.linkedin.com'
    }
  ];

  return (
    <section id="team" className="py-24 bg-esthe-cafe-noir">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-8 mb-4">
            <div className="h-px w-24 bg-esthe-tan/30"></div>
            <h2 className="text-5xl font-bold text-esthe-floral-white">Meet Our Experts</h2>
            <div className="h-px w-24 bg-esthe-tan/30"></div>
          </div>
          <p className="text-esthe-tan text-lg">
            Board-certified professionals dedicated to your care
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {team.map((member, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6 inline-block">
                <div className="w-60 h-60 mx-auto rounded-full overflow-hidden border-4 border-esthe-tan shadow-xl group-hover:scale-105 transition-transform duration-300">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h3 className="text-xl font-bold text-esthe-floral-white mb-2">{member.name}</h3>
              <p className="text-esthe-tan text-base mb-4">{member.role}</p>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-10 h-10 border-2 border-esthe-tan/50 rounded-full text-esthe-tan hover:bg-esthe-tan hover:text-esthe-cafe-noir transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
